import React, { useMemo } from "react";

import styles from './StatusInputWrapper.module.scss'
export const StatusInputWrapper = ({ t, isValid, errorMsg, label, customClasses, isFocussed, ...inputProps }) => {

    const statusClasses = useMemo(() => {
        if (isValid === '') {
            return 'ns-form-group';
        }
        else if (isValid === true) {
            return 'ns-form-group has-success'
        } else {
            return 'ns-form-group has-error ns-form-group-message-error'
        }
    }, [isValid])

    const inputClasses = useMemo(() => {
        if (isValid === '') {
            return 'ns-input';
        }
        else if (isValid === true) {
            return 'ns-input ns-input--success'
        } else {
            return 'ns-input ns-input--error'
        }

    }, [isValid])

    return (
        <div className={[
            statusClasses,
            styles['fields_margin'],
        ].join(' ')}>
            <div className="ns-label-wrapper">
                <label className="ns-label" htmlFor={inputProps.name}>
                    {label}
                </label>
            </div>
            {(!isValid && isValid !== '') && (
                <span id="street-address-error" className={isFocussed ? 'help-block-focused' : 'help-block'}>
                    <i aria-label={t('shared.error')} className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
                    <span className="ns-visually-hidden">{t('shared.error')}</span> {t(errorMsg)}
                </span>
            )}
            <div style={{ display: "flex", overflow: "auto" }}>
                <input className={inputClasses + ' ' + customClasses} style={{ flexGrow: 1, minWidth: "3em" }}{...inputProps} />
                {(isValid === true) && (
                    <div style={{ display: "inline-flex", marginLeft: "1rem", alignItems: "center" }} ><i className="fa fa-check-circle fa-lg" aria-hidden="true"></i></div>
                )}
            </div>

        </div>
    )
}